{
  "comment": "MC-h4a (RD7(d), D-505): who buys First Rush spares and the player-facing text. Prices are career.json rushSpares (base x premium per unit, standingGain per unit).",
  "buyer": "holdfast",
  "name": "Rush spares",
  "text": {
    "noService": "{station} does not buy Rush spares.",
    "notTraded": "Goods trading is not open yet.",
    "notInHold": "Only {held} Rush spares in the hold.",
    "wholeUnits": "Rush spares sell in whole units.",
    "notDocked": "Dock at the station to sell Rush spares.",
    "rowLabel": "Sold to the {faction} at a premium",
    "standingLabel": "+{gain} {faction} standing per spare"
  }
}
